// extracted by mini-css-extract-plugin
export default {"Tag":"sGstrlKR"};